module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: (_vm.className + " label")
  }, [(_vm.inputType == "date" || _vm.inputType == "time") ? [_c('div', {
    staticClass: "v-datepicker"
  }, [_c('datepicker', {
    attrs: {
      "date": _vm.startTime,
      "option": _vm.datepicker.option,
      "limit": _vm.limit
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "reset-datepicker",
    on: {
      "click": _vm.resetDatepicker
    }
  })], 1)] : [(_vm.inputType == "text") ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "name": _vm.name
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "keyup": _vm.identicmethod,
      "focus": _vm.clearError,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }) : (_vm.inputType == "tel") ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    attrs: {
      "type": "tel",
      "name": _vm.name,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "focus": _vm.clearError,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }) : (_vm.inputType == "email") ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    attrs: {
      "type": "email",
      "name": _vm.name,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "focus": _vm.clearError,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }) : (_vm.inputType == "password") ? _c('div', {
    class: _vm.showPass ? "showPassword show" : "showPassword"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    attrs: {
      "type": "password",
      "placeholder": _vm.placeholder,
      "name": _vm.name
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "keyup": _vm.identicmethod,
      "focus": _vm.clearError,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "name": _vm.name
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "keyup": _vm.identicmethod,
      "focus": _vm.clearError,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "eye",
    on: {
      "click": function($event) {
        _vm.showPass = !_vm.showPass
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "focus-bg"
  })]) : (_vm.inputType == "checkbox") ? _c('div', {
    class: _vm.novalide ? "wrapper" : "wrapper error"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.name
    },
    domProps: {
      "checked": Array.isArray(_vm.inputValue) ? _vm._i(_vm.inputValue, null) > -1 : (_vm.inputValue)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.inputValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.inputValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.inputValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.inputValue = $$c
        }
      }, _vm.noerror]
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "focus-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "validation-errors"
  }, [(_vm.validator) ? _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    staticClass: "serverError-message"
  }, [_vm._v(_vm._s(_vm.validator))])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMessage.required),
      expression: "showMessage.required"
    }],
    staticClass: "required"
  }, [_vm._v(_vm._s(_vm.textRequired))])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMessage.wrongSymbol && !_vm.mask.complete),
      expression: "showMessage.wrongSymbol && !mask.complete"
    }],
    staticClass: "wrong-symbol",
    domProps: {
      "innerHTML": _vm._s(_vm.textWrongSymbol)
    }
  })])], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c407f4d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/forms/elements/input.vue
// module id = 267
// module chunks = 35